import "./scss/index.scss";

import isEqual from "lodash/isEqual";
import * as React from "react";

import { ProductVariantPicker } from "@components/organisms";
import { ICheckoutModelLine } from "@saleor/sdk/lib/helpers";
import {
  ProductDetails_product_pricing,
  ProductDetails_product_variants,
  ProductDetails_product_variants_pricing,
} from "@saleor/sdk/lib/queries/gqlTypes/ProductDetails";
import { IProductVariantsAttributesSelectedValues, ITaxedMoney } from "@types";
import { Link } from "react-router-dom";
import { generateStoreUrl } from "src/core/utils";

import { TaxedMoney } from "../../@next/components/containers";
import AddToCart from "./AddToCart";
import { QuantityTextField } from "./QuantityTextField";

import { SubDetails } from "@components/containers";
import { ProductDetails_merchant } from "src/views/Product/gqlTypes/ProductDetails";

import { convertMinutesToHoursDaysString } from "src/helpers";

// import { Link } from "@temp/@next/components/atoms/DemoBanner/styles";

const LOW_STOCK_QUANTITY = 5;
interface ProductDescriptionProps {
  productId: string;
  productVariants: ProductDetails_product_variants[];
  name: string;
  merchant: ProductDetails_merchant | null;
  leadTime: number | null;
  pricing: ProductDetails_product_pricing;
  items: ICheckoutModelLine[];
  queryAttributes: Record<string, string>;
  addToCart(varinatId: string, quantity?: number): void;
  setVariantId(variantId: string);
  onAttributeChangeHandler(slug: string | null, value: string): void;

}

interface ProductDescriptionState {
  quantity: number;
  variant: string;
  variantStock: number;
  variantPricing: ProductDetails_product_variants_pricing;
  variantPricingRange: {
    min: ITaxedMoney;
    max: ITaxedMoney;
  };

}

class ProductDescription extends React.Component<
  ProductDescriptionProps,
  ProductDescriptionState
> {
  constructor(props: ProductDescriptionProps) {
    super(props);

    this.state = {
      quantity: 1,
      variant: "",
      variantPricing: null,
      variantPricingRange: {
        max: props.pricing.priceRange.stop,
        min: props.pricing.priceRange.start,
      },
      variantStock: null,
    };
  }

  getProductPrice = () => {
    const { variantPricingRange, variantPricing } = this.state;

    const { min, max } = variantPricingRange;
    if (variantPricing) {
      if (isEqual(variantPricing.priceUndiscounted, variantPricing.price)) {
        return <TaxedMoney taxedMoney={variantPricing.price} />;
      } else {
        return (
          <>
            <span className="product-description__undiscounted_price">
              <TaxedMoney taxedMoney={variantPricing.priceUndiscounted} />
            </span>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <TaxedMoney taxedMoney={variantPricing.price} />
          </>
        );
      }
    }
    if (isEqual(min, max)) {
      return <TaxedMoney taxedMoney={min} />;
    } else {
      return (
        <>
          <TaxedMoney taxedMoney={min} /> - <TaxedMoney taxedMoney={max} />
        </>
      );
    }
  };

  onVariantPickerChange = (
    _selectedAttributesValues?: IProductVariantsAttributesSelectedValues,
    selectedVariant?: ProductDetails_product_variants
  ) => {
    if (selectedVariant) {
      this.setState({
        variant: selectedVariant.id,
        variantPricing: selectedVariant.pricing,
        variantStock: selectedVariant.quantityAvailable,
      });
      this.props.setVariantId(selectedVariant.id);
    } else {
      this.setState({ variant: "", variantPricing: null });
      this.props.setVariantId("");
    }
  };

  canAddToCart = () => {
    const { items } = this.props;
    const { variant, quantity, variantStock } = this.state;

    const cartItem = items?.find(item => item.variant.id === variant);
    const syncedQuantityWithCart = cartItem
      ? quantity + (cartItem?.quantity || 0)
      : quantity;
    return quantity !== 0 && variant && variantStock >= syncedQuantityWithCart;
  };

  handleSubmit = () => {
    this.props.addToCart(this.state.variant, this.state.quantity);
    this.setState({ quantity: 0 });
  };

  getAvailableQuantity = () => {
    const { items } = this.props;
    const { variant, variantStock } = this.state;

    const cartItem = items?.find(item => item.variant.id === variant);
    const quantityInCart = cartItem?.quantity || 0;
    return variantStock - quantityInCart;
  };

  handleQuantityChange = (quantity: number) => {
    this.setState({
      quantity,
    });
  };

  renderErrorMessage = (message: string) => (
    <p className="product-description__error-message">{message}</p>
  );

  render() {
    const { name, leadTime, merchant} = this.props;
    const { warehouses } = merchant;
    const { variant, variantStock, quantity } = this.state;
    const availableQuantity = this.getAvailableQuantity();
    const isOutOfStock = !!variant && variantStock === 0;
    const isNoItemsAvailable = !!variant && !isOutOfStock && !availableQuantity;
    const isLowStock =
      !!variant &&
      !isOutOfStock &&
      !isNoItemsAvailable &&
      availableQuantity < LOW_STOCK_QUANTITY;
    
    const address =
    warehouses &&
    warehouses.edges &&
    warehouses.edges.length > 0 &&
    warehouses.edges[0].node &&
    warehouses.edges[0].node.address
      ? warehouses.edges[0].node.address
      : null;
      
    return (
      <div className="product-description">
        <div className="product-description__merchant">            
        <Link to={generateStoreUrl(merchant?.slug || "")}>{merchant?.storeTitle ? merchant?.storeTitle: " "}</Link>
        <div className="product-description__address">
        <SubDetails
            items={[
            {
              // iconName: 'fas fa-map-marker-alt',
              text: address?.city,
              toolTip: "Store Location"
            },
          ]}
        />
        </div> 
        </div>
        <h3>{name}</h3>
        
            {/* {this.getProductPrice()} */}
                  
        {isOutOfStock ? (
          this.renderErrorMessage("Out of stock")
        ) : (
          <div className="product-description__price">
            {/* {this.getProductPrice()} */}
            <SubDetails items={[  
              { component: this.getProductPrice()},
              { 
                alignRight: true,
                iconName: "far fa-clock", 
                iconSize: 16,
                text: leadTime ? convertMinutesToHoursDaysString(leadTime) : null, 
                toolTip: "Item Preparation Time"
              },
            ]} />
          </div>
        )}

        {isLowStock && this.renderErrorMessage("Low stock")}
        {isNoItemsAvailable && this.renderErrorMessage("No items available")}
        <div className="product-description__variant-picker">
          <ProductVariantPicker
            productVariants={this.props.productVariants}
            onChange={this.onVariantPickerChange}
            selectSidebar={true}
            queryAttributes={this.props.queryAttributes}
            onAttributeChangeHandler={this.props.onAttributeChangeHandler}
          />
        </div>
        <div className="product-description__wrapper">
        <div className="product-description__quantity-input">
          <QuantityTextField
            quantity={quantity}
            maxQuantity={availableQuantity}
            disabled={isOutOfStock || isNoItemsAvailable}
            onQuantityChange={this.handleQuantityChange}
            hideErrors={!variant || isOutOfStock || isNoItemsAvailable}
          />
        </div>
        <AddToCart
          onSubmit={this.handleSubmit}
          disabled={!this.canAddToCart()}
        />
        </div>
        <p className="product-description__bulkOrders">
          For <strong>bulk orders</strong>, please call our hotline at <span style={{display: 'inline-block'}}>(02) 8864-7777</span> or 
          send us an email at bulkorders@jrmall.ph        
        </p>
      </div>
    );
  }
}

export default ProductDescription;
